import gql from 'graphql-tag'

export const eligibilityTemplateUpdate = gql`
  mutation EligibilityTemplateUpdate($input: EligibilityTemplateUpdateInput!) {
    eligibilityTemplateUpdate(input: $input) {
      success
    }
  }
`
